import { el, setChildren, setAttr } from 'redom';

import application from 'application';
import externalEventCodes from 'event-system/codes/external';

import MeetingEndedBackgroundImage from 'assets/images/livestream-background-image.png';

class EndedView {

  constructor(meeting) {

    this.recordingVideo = null;
    this.meeting = meeting;

    const recording = this.meeting.recording;

    this.initializeRecordingUnavailableView();

    this.el = el('.ended-view-main', this.endedMeetingContent);

  }

  onmount() {

    this.tryRegisterMeetingRecordingReadyEvent();
    this.tryRegisterMeetingRecordingProcessedEvent();

  }

  tryRegisterMeetingRecordingReadyEvent() {

    const postId = this.meeting.postId;

    if (this.meeting.recording.async === true && this.meeting.recording.completedAt !== null) {
      return;
    }

    let handler = function handleMeetingRecordingReadyEvent(data) {

      application.eventSystem.internal.off(`${externalEventCodes.SINGLE_PRODUCER_MEETING_RECORDING_READY}:${postId}`, handler);

      this.updateRecordingVideo(data.meeting);

    }.bind(this);

    application.eventSystem.internal.on(`${externalEventCodes.SINGLE_PRODUCER_MEETING_RECORDING_READY}:${postId}`, handler);

  }

  tryRegisterMeetingRecordingProcessedEvent() {

    const postId = this.meeting.postId;

    if (this.meeting.recording.async !== true) {
      return;
    }

    let handler = function handleMeetingRecordingProcessedEvent(data) {

      application.eventSystem.internal.off(`${externalEventCodes.SINGLE_PRODUCER_MEETING_RECORDING_PROCESSED}:${postId}`, handler);

      this.updateRecordingVideo(data.meeting);

    }.bind(this);

    application.eventSystem.internal.on(`${externalEventCodes.SINGLE_PRODUCER_MEETING_RECORDING_PROCESSED}:${postId}`, handler);

  }

  initializeRecordingUnavailableView() {

    this.meetingEndedLabel = el('span.meeting-ended-label', 'Live Streaming has ended');
    this.recordingAvailabilityLabel = el('span.ended-meeting-recording-availability-label', 'Recording will become available soon!');
    this.endedMeetingBackgroundImageViewEL = el('img.ended-meeting-background-image-view', { src: MeetingEndedBackgroundImage, alt: 'event background image' });
    this.endedMeetingBackgroundImageContainerEl = el('.ended-view-backgrund-image-container', [this.endedMeetingBackgroundImageViewEL]);

    this.endedMeetingContent = el('.ended-meeting-banner', [this.meetingEndedLabel]);

  }

  initializeRecordingAvailableView() {
    this.recordingVideo = el('ht-video.meeting-recording-video', {
      src: this.meeting.recording.url,
      source: this.meeting.recording.url,
      roundedcorners: true
    });
    this.endedMeetingContent = el('.meeting-recording-video-container', [this.recordingVideo]);

  }

  updateRecordingVideo(meeting) {

    this.meeting = meeting;

    let currentTime = 0;

    if (this.recordingVideo === null) {
      this.initializeRecordingAvailableView();
      setChildren(this.el, this.endedMeetingContent);
    } else {
      currentTime = this.recordingVideo.currentTime;
    }

    setAttr(this.recordingVideo, {
      src: this.meeting.recording.url,
      source: this.meeting.recording.url,
      muted: true
    });

    this.recordingVideo.onloadedmetadata = function onMetadataLoaded() {
      this.currentTime = currentTime;
      if (this.currentTime > 0) {
        this.play();
      }
    };

  }

  playVideo() {

    if (this.recordingVideo === null) {
      return;
    }

    this.recordingVideo.play();

  }

  stopVideo() {

  }

}

export default EndedView;